import { Container, Grid, Paper } from '@material-ui/core'
import React, { useState } from 'react'
import { components, useTranslation } from 'cng-web-lib'

import AccessLevelRuleViewForm from './AccessLevelRuleViewForm'
import AccessLevelRuleAddForm from './AccessLevelRuleAddForm'
import AccessLevelRuleEditForm from './AccessLevelRuleEditForm'
import AccessLevelRulePermissionCrudTable from './AccessLevelRulePermissionCrudTable'
import Namespace from 'src/constants/locale/Namespace'
import AccessLevelRuleKeys from 'src/constants/locale/key/AccessLevelRule'
import {
  constants,
} from 'cng-web-lib'

const {
  locale: {
    key: {
      UiComponentKeys,
    },
  },
} = constants

const { CngTabs } = components

function AddPage({ history, showNotification }) {
  const [lockedOnFirstTab, setLockedOnFirstTab] = useState(true)
  const [accessLevelRuleId, setAccessLevelRuleId] = useState('')
  const { translate } = useTranslation([
    Namespace.ACCESS_LEVEL_RULE,
    Namespace.UI_COMPONENT
  ])
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let accessLevelRule = translate(
      Namespace.ACCESS_LEVEL_RULE,
      AccessLevelRuleKeys.TITLE
    )
    let accessLevelRulePermission = translate(
      Namespace.ACCESS_LEVEL_RULE,
      AccessLevelRuleKeys.AccessLevelRulePermission.TITLE
    )
    let tabLockedMessage = translate(
      Namespace.UI_COMPONENT,
      UiComponentKeys.Tabs.PLEASE_SUBMIT_FIRST,
      {
        title: accessLevelRule
      }
    )

    return {
      accessLevelRule,
      accessLevelRulePermission,
      tabLockedMessage
    }
  }

  function makeAccessLevelRuleForm() {
    if (accessLevelRuleId === '') {
      return (
        <AccessLevelRuleAddForm
          history={history}
          showNotification={showNotification}
          onPostSubmitSuccess={(datum) => {
            console.log("AddPage Rule id:[" + datum.id + "]");
            setAccessLevelRuleId(datum.id)
            setLockedOnFirstTab(false)
          }}
        />
      )
    } else {
      return (
        <AccessLevelRuleEditForm
          showNotification={showNotification}
          id={accessLevelRuleId}
        />
      )
    }
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper>
          <Container maxWidth='xl'>
            <AccessLevelRuleViewForm
              showNotification={showNotification}
              id={accessLevelRuleId}
            />
          </Container>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <CngTabs
          headerColor='primary'
          tabs={[
            {
              tabName: translatedTextsObject.accessLevelRule,
              tabContent: makeAccessLevelRuleForm()
            },
            {
              tabName: translatedTextsObject.accessLevelRulePermission,
              tabContent: (
                <AccessLevelRulePermissionCrudTable
                  showNotification={showNotification}
                  accessLevelRuleId={accessLevelRuleId}
                />
              )
            },
          ]}
          lockedOnFirstTab={lockedOnFirstTab}
          tabLockedMessage={translatedTextsObject.tabLockedMessage}
        />
      </Grid>
    </Grid>
  )
}

export default AddPage